import {BASIC_URL} from "../enum";

async function getIndustrieObjectsWithFilters(filters, lang) {
  // console.log("FILTERS: " + JSON.stringify(filters))

  const params = new URLSearchParams();
  params.append('locale', lang);
  // Strapi caps pageSize at its maxLimit (100), so results have to be
  // fetched page by page - a single oversized request silently drops entries.
  params.append('pagination[pageSize]', 100);
  params.append('populate', '*');

  if (filters.search) params.append('filters[Company][$containsi]', filters.search);
  if (filters.productsAndServices) {
    filters.productsAndServices.forEach((element, index) => {
      params.append(`filters[product_services][Name][$in][${index}]`, element);
    })
  }
  if (filters.technologies) {
    filters.technologies.forEach((element, index) => {
      params.append(`filters[technologies][Name][$in][${index}]`, element);
    })
  }
  if (filters.fieldsAndProfiles) {
    filters.fieldsAndProfiles.forEach((element, index) => {
      params.append(`filters[field_profiles][Name][$in][${index}]`, element);
    })
  }
  if (filters.typeOfIndustries) {
    filters.typeOfIndustries.forEach((element, index) => {
      params.append(`filters[type_of_industries][Name][$in][${index}]`, element);
    })
  }
  if (filters.companySizes) {
    filters.companySizes.forEach((element, index) => {
      params.append(`filters[company_size][$in][${index}]`, element);
    })
  }
  if (filters.companyTypes) {
    filters.companyTypes.forEach((element, index) => {
      params.append(`filters[company_type][$in][${index}]`, element);
    })
  }

  const industrieObjects = [];

  try {
    let page = 1;
    let pageCount = 1;

    do {
      params.set('pagination[page]', page);
      const url = `${BASIC_URL}/api/industrie-objects?${params.toString()}`;
      // console.log('URL: ' + url + ' FOR FILTERS: ' + JSON.stringify(filters))

      const response = await fetch(new Request(url));
      const data = await response.json();

      if (data.data == null) {
        console.warn("STRAPI RESPONSE: is null => load empty list")
        return industrieObjects;
      }

      for (const industrieObject of data.data) {
        industrieObjects.push(industrieObject)
      }

      pageCount = data.meta?.pagination?.pageCount ?? 1;
      page++;
    } while (page <= pageCount);

    // console.log("GOT INDUSTRIE OBJECTS FROM STRAPI: " + industrieObjects.length + " FOR FILTERS: " + JSON.stringify(filters))
    return industrieObjects;
  } catch (error) {
    console.error(error)
    return industrieObjects;
  }
}

function getTags(tagName: string, query: string, lang: string) {
  const tags = [];

  return fetch(new Request(`${BASIC_URL}/api/${tagName}?pagination[pageSize]=1000&filters[Name][$containsi]=${query}&locale=${lang}`))
    .then((response) => response.json())
    .then((data) => {
      if (data.data == null) {
        // console.log(`STRAPI TAG=${tagName} LOCALE=${lang} RESPONSE: is null => load empty list`)
        return tags;
      }

      for (const tag of data.data) {
        tags.push(tag)
      }
      // console.log(`GOT TAGS(${tagName}) LOCALE=${lang} FROM STRAPI: ${tags.length}`)
      return tags;
    })
    .catch(error => {
      console.error(error)
      return tags;
    });
}

function getTypeOfIndustries(query: string, lang: string) {
  return getTags('type-of-industries', query, lang)
}

function getProductsAndServices(query: string, lang: string) {
  return getTags('products-services', query, lang)
}

function getFieldsAndProfiles(query: string, lang: string) {
  return getTags('field-profiles', query, lang)
}

function getTechnologies(query: string, lang: string) {
  return getTags('technologies', query, lang)
}

function getCurrentUser() {
  const token = localStorage.getItem('jwt');
  const request = new Request(`${BASIC_URL}/api/users/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return fetch(request)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Failed to fetch user');
      }
      return  response.json()
    });
}

function getSeo(lang) {
  const request = new Request(`${BASIC_URL}/api/seo?locale=${lang}`);

  return fetch(request)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Failed to fetch seo');
      }
      return response.json()
    });
}

export default {getIndustrieObjectsWithFilters, getTypeOfIndustries, getProductsAndServices, getFieldsAndProfiles, getTechnologies, getCurrentUser, getSeo, getTags}
